import {
  CreateRecommendationCategory,
  CreateRecommendationCategoryCompleted,
  CreateRecommendationCategoryFailed,
  CreateRecommendationTemplate,
  CreateRecommendationTemplateCompleted,
  CreateRecommendationTemplateFailed,
  CreateRecommendationTemplateRule,
  CreateRecommendationTemplateRuleCompleted,
  CreateRecommendationTemplateRuleFailed,
} from './recommendation-create.action';
import {
  DeleteEmployeeRecommendation,
  DeleteEmployeeRecommendationCompleted,
  DeleteEmployeeRecommendationFailed,
  DeleteRecommendationCategory,
  DeleteRecommendationCategoryCompleted,
  DeleteRecommendationCategoryFailed,
  DeleteRecommendationTemplate,
  DeleteRecommendationTemplateCompleted,
  DeleteRecommendationTemplateFailed,
  DeleteRecommendationTemplateRule,
  DeleteRecommendationTemplateRuleCompleted,
  DeleteRecommendationTemplateRuleFailed,
} from './recommendation-delete.action';
import {
  LoadEmployeeRecommendations,
  LoadEmployeeRecommendationsCompleted,
  LoadEmployeeRecommendationsFailed,
  LoadRecommendationsLibrary,
  LoadRecommendationsLibraryCompleted,
  LoadRecommendationsLibraryFailed,
  LoadRecommendationTemplate,
  LoadRecommendationTemplateCompleted,
  LoadRecommendationTemplateFailed,
} from './recommendation-load.action';
import {
  SelectEmployeeRecommendation,
  SelectEmployeeRecommendationCompleted,
  SelectEmployeeRecommendationFailed,
} from './recommendation-select.action';
import {
  UpdateEmployeeRecommendation,
  UpdateEmployeeRecommendationCompleted,
  UpdateEmployeeRecommendationFailed,
  UpdateRecommendationCategory,
  UpdateRecommendationCategoryCompleted,
  UpdateRecommendationCategoryFailed,
  UpdateRecommendationTemplate,
  UpdateRecommendationTemplateCompleted,
  UpdateRecommendationTemplateFailed,
  UpdateRecommendationTemplateRule,
  UpdateRecommendationTemplateRuleCompleted,
  UpdateRecommendationTemplateRuleFailed,
} from './recommendation-update.action';

export { RecommendationActionType } from './recommendation-action-type.enum';

export * from './recommendation-load.action';
export * from './recommendation-update.action';
export * from './recommendation-select.action';
export * from './recommendation-delete.action';
export * from './recommendation-create.action';

export type RecommendationActions =

  CreateRecommendationCategory |
  CreateRecommendationCategoryCompleted |
  CreateRecommendationCategoryFailed |

  CreateRecommendationTemplate |
  CreateRecommendationTemplateCompleted |
  CreateRecommendationTemplateFailed |

  CreateRecommendationTemplateRule |
  CreateRecommendationTemplateRuleCompleted |
  CreateRecommendationTemplateRuleFailed |

  LoadEmployeeRecommendations |
  LoadEmployeeRecommendationsCompleted |
  LoadEmployeeRecommendationsFailed |

  LoadRecommendationTemplate |
  LoadRecommendationTemplateCompleted |
  LoadRecommendationTemplateFailed |

  LoadRecommendationsLibrary |
  LoadRecommendationsLibraryCompleted |
  LoadRecommendationsLibraryFailed |

  UpdateEmployeeRecommendation |
  UpdateEmployeeRecommendationCompleted |
  UpdateEmployeeRecommendationFailed |

  UpdateRecommendationTemplate |
  UpdateRecommendationTemplateCompleted |
  UpdateRecommendationTemplateFailed |

  UpdateRecommendationTemplateRule |
  UpdateRecommendationTemplateRuleCompleted |
  UpdateRecommendationTemplateRuleFailed |

  UpdateRecommendationCategory |
  UpdateRecommendationCategoryCompleted |
  UpdateRecommendationCategoryFailed |

  SelectEmployeeRecommendation |
  SelectEmployeeRecommendationCompleted |
  SelectEmployeeRecommendationFailed |

  DeleteEmployeeRecommendation |
  DeleteEmployeeRecommendationCompleted |
  DeleteEmployeeRecommendationFailed |

  DeleteRecommendationTemplate |
  DeleteRecommendationTemplateCompleted |
  DeleteRecommendationTemplateFailed |

  DeleteRecommendationTemplateRule |
  DeleteRecommendationTemplateRuleCompleted |
  DeleteRecommendationTemplateRuleFailed |

  DeleteRecommendationCategory |
  DeleteRecommendationCategoryCompleted |
  DeleteRecommendationCategoryFailed;
